import { FunctionComponent } from "react";
import styled from "styled-components";

import ImagePillContent from "./ImagePillContent";
import { colours } from "@/utils";
import { Device } from "@/utils/device";

const subheading =
  "For managers, early-stage founders or mid-level professionals, ready to transform and accelerate their career journey.";

const copy = [
  "With tailored coaching and skill-building opportunities, Accelerate will equip you to secure that long-awaited promotion, negotiate for a higher salary, and gain the influence and impact you deserve within your organisation. Available as an in-person or online programme.",
  "We also offer Tech Accelerate, a dedicated programme designed specifically for women in the technology sector.",
];

const Title: FunctionComponent = () => {
  return (
    <S.Title>
      A<i>cc</i>elerate
    </S.Title>
  );
};

const AccelerateContent: FunctionComponent = () => {
  return (
    <ImagePillContent
      id="accelerate"
      href="/accelerate"
      title={<Title />}
      subheading={subheading}
      copy={copy}
      linkText="Accelerate your career"
      imagePath="/images/marketing/hsbc-pitch-day.jpg"
    />
  );
};

const S = () => {};

S.Title = styled.h2`
  font-size: 7rem;
  font-weight: 100;
  color: ${colours.marketingOrange};

  @media (min-width: ${Device.tablet}) {
    font-size: 8rem;
  }

  @media (min-width: ${Device.desktop}) {
    font-size: 10rem;
  }
`;

export default AccelerateContent;
